import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <a
        href="https://github.com/anasilva81/weather-project"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open-source code
      </a>{" "}
      by{" "}
      <a
        href="https://illustrious-faun-bd17c1.netlify.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Ana Moreira da Silva
      </a>{" "}
    </div>
  );
}
